import React from 'react'
import { useTranslation } from 'react-i18next'
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip'
import type { ScheduleStats } from '../types'

/**
 * Three inline counts: on track (success), at risk (warning), delayed (danger); tooltip lists all four.
 * `text-success` / `text-warning` are not Tailwind colours in this project (only
 * CSS custom properties meant for buttons/alerts) — reuse the same raw palette
 * classes `badgeVariants` uses for its success/warning/danger text so this stays
 * on the one true state→colour mapping instead of inventing a second one.
 */
const HealthCounts: React.FC<{ stats: ScheduleStats }> = ({ stats }) => {
  const { t } = useTranslation()
  return (
    <TooltipProvider delayDuration={200}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span className="inline-flex items-center gap-2 text-sm tabular-nums">
            <span className="text-green-700">{stats.onTrack}</span>
            <span className="text-amber-700">{stats.atRisk}</span>
            <span className="text-red-700">{stats.delayed}</span>
          </span>
        </TooltipTrigger>
        <TooltipContent>
          <div className="text-xs space-y-0.5">
            <div>{t('Schedule_health_ON_TRACK')}: {stats.onTrack}</div>
            <div>{t('Schedule_health_AT_RISK')}: {stats.atRisk}</div>
            <div>{t('Schedule_health_DELAYED')}: {stats.delayed}</div>
            <div>{t('Schedule_health_COMPLETED')}: {stats.completed}</div>
          </div>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}
export default HealthCounts
